import React from "react";
import { Modal } from "react-bootstrap";
import Webcam from "react-webcam";
import { IMAGES } from "../../../../assets";

const StartMeeting = ({ show, onHide }) => {
  return (
    <div>
      <Modal show={show} onHide={onHide} backdrop="static" keyboard={false}>
        <Modal.Header closeButton className="py-1">
          <Modal.Title>
            <div className="d-flex align-items-center">
              <img src={IMAGES.ZOOMLOGO} className="zoom-metting-logo" />
              <span className="f-13 pl-2">Covis Meeting</span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="vedio-Body px-0">
          <div className="pt-5">
            <Webcam className="w-100" />
            <div className="d-flex text-right pt-3 pb-2 px-3 justify-content-end">
              <button
                onClick={onHide}
                className="f-14 vedioCall-end bg-danger text-white rounded"
              >
                End
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default StartMeeting;
